import { forwardRef } from 'react';
import Panel from '../shared/Panel/Panel';
import { RichTextEditor } from '../shared/RichTextEditor';
import type { RichTextEditorHandle } from '../shared/RichTextEditor';

interface ConclusionsPanelProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
}

const ConclusionsPanel = forwardRef<
  RichTextEditorHandle,
  ConclusionsPanelProps
>(({ value, onChange, disabled = false, onFocus, onBlur }, ref) => (
  <Panel title="Conclusions">
    <RichTextEditor
      ref={ref}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
      placeholder="Enter conclusions (use the toolbar for formatting)"
      testId="conclusion-editor"
    />
  </Panel>
));

export default ConclusionsPanel;
